import React, { useContext, useEffect, useState } from 'react';
import { ExamData, ExamDetails, ResponsesData, SelectedQuestion } from '../context';
import ExamQuestion from './ExamQuestion/ExamQuestion';
import { IOptionsData } from './ExamQuestion/ExamQuestion.options';
import { defaultTheme } from '../../../../components/nx';

const t = defaultTheme;

interface IExamQuestionBody {
    onUserResponseChange: any;
    userAnswers: IOptionsData[] | undefined;
    disabled: boolean;
}

export default function ExamQuestionBody(props: IExamQuestionBody) {
    const examData: any = useContext(ExamData);
    const { responsesData } = useContext<any>(ResponsesData);
    const { selectedQuestionId } = useContext<any>(SelectedQuestion);

    const [selectedQuestionIndex, setSelectedQuestionIndex] = useState<number>(0);
    const [totalQuestions, setTotalQuestions] = useState<number>(0);
    const [currentSectionData, setCurrentSectionData] = useState<any>();
    const [selectedQuestionData, setSelectedQuestionData] = useState<any>();

    useEffect(() => {
        const sectionData = responsesData?.questionArr.find((res: any) => res.section === selectedQuestionId.section);
        const questionIndex = sectionData?.questions.findIndex((i: any) => i === selectedQuestionId.question);
        setSelectedQuestionIndex(questionIndex || 0);
        setCurrentSectionData(sectionData);
        setTotalQuestions(sectionData?.questions?.length || 0);
    }, [selectedQuestionId, responsesData]);

    const extractSelectedQuestionData = () => {
        const question_section = examData?.data.find((section: any) => section._id === selectedQuestionId?.section);
        if (question_section) {
            const question_selected_data = question_section?.questionData?.find((question: any) => question._id === selectedQuestionId.question);
            setSelectedQuestionData(question_selected_data);
        }
    };

    const handleReponseChange = (e: any) => {
        props.onUserResponseChange({
            questionId: selectedQuestionId.question,
            optionsData: e,
        });
    };

    useEffect(() => {
        extractSelectedQuestionData();
    }, [examData, selectedQuestionId]);

    return (
        <div>
            {/* Question header */}
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 18 }}>
                <div>
                    <div style={{ fontSize: 11, letterSpacing: '0.1em', textTransform: 'uppercase', color: t.inkMute, fontWeight: 600 }}>
                        Question {selectedQuestionIndex + 1} of {totalQuestions}
                    </div>
                </div>
            </div>

            {/* Question body */}
            {selectedQuestionData ? (
                <ExamQuestion
                    questionData={selectedQuestionData}
                    questionResponses={currentSectionData}
                    language={selectedQuestionId?.language || "english"}
                    onUserResponseChange={handleReponseChange}
                    userAnswers={props.userAnswers}
                    disabled={props.disabled}
                />
            ) : (
                <div style={{ padding: 20, color: t.inkMute }}>Loading question...</div>
            )}
        </div>
    );
}
